import {
  DeleteOutlined,
  DownloadOutlined,
  FallOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  Upload,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";

import { ReactComponent as About } from "../../../image/About.svg";
import { ReactComponent as AddressLine } from "../../../image/AddressLine.svg";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import { ReactComponent as Email } from "../../../image/Email.svg";
import { ReactComponent as FileAlt } from "../../../image/FileAlt.svg";
import { ReactComponent as IdcardOutlined } from "../../../image/IdcardOutlined.svg";
import { ReactComponent as Name } from "../../../image/Name.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import { ReactComponent as User } from "../../../image/User.svg";
import { ReactComponent as Vector } from "../../../image/Vector.svg";
import verifybtn from "../../../image/verifybtn.png";
import { ReactComponent as Website } from "../../../image/Website.svg";
import { ReactComponent as ZipCode } from "../../../image/ZipCode.svg";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import KeyPersonCompany from "../../mycompany/KeyPersonCompany";
import RiskAndCompliance from "../../settings/RiskAndCompliance";
import jsPDF from "jspdf";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../../axios";
import CompanyOnboardingLogo from "../../companyOnboarding/CompanyOnboardingLogo";
import InputField from "../../../common/htmlComponents/InputField";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import TextAreaField from "../../../common/htmlComponents/TextAreaField";
import EmailField from "../../../common/htmlComponents/EmailField";
import VerifyOtpModal from "../../../authentication/VerifyOtpModel";
import PhoneOtpVerify from "../../../authentication/PhoneOtpVerify";
import PropTypes from "prop-types";

const { Search } = Input;
const AddNewClient = ({
  handleCancel1,
  setIsModalOpen,
  isModalOpen,
  getCompanyOnboardingList,
  setReload,
  reload
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  console.log('idcxz', id);
  
  const navigate = useNavigate();
  const CompanyId = id ? atob(id) : null;
  console.log('CompanyIdcx', CompanyId);
  
  const { Panel } = Collapse;
  const formRef = useRef();
  const initialDocument = { company: null, attachment_name: null };
  const initialState = {
    name: null,
    first_name: null,
    designation: null,
    email: null,
    phone: null,
    address_line_1: null,
    address_line_2: null,
    city: null,
    state: null,
    pincode: null,
    website: null,
    no_of_employees: null,
    company_pan: null,
    gst_no: null,
    email_verified: false,
    phone_verified: false,
    pan_verified: false,
    udyam_aadhaar_no_verified: false,
    gst_no_verified: false,
    about_company: null,
    sector: null,
    cin_no: null,
    // risk_and_compliance_title: false,
    keypersons: [
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
      },
    ],
  };

  const [state, setState] = useState(initialState);
  const [documentState, setDocumentState] = useState(initialDocument);
  const [verificationResultGST, setVerificationResultGST] = useState(null);
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verifyGstDisable, setVerifyDisable] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [searchValueShipping, setSearchValueShipping] = useState("");
  const [verifyPancard, setVerifyPancard] = useState(false);
  const [verifyPancardButtonView, setVerifyPancardButtonView] = useState(true);
  const [verificationResultPancard, setVerificationResultPancard] =
    useState(null);
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [fileLinkadhar, setFileLinkadhar] = useState(null);
  const [fileLinkPan, setFileLinkPan] = useState(null);
  const [fileLinkGst, setFileLinkGst] = useState(null);
  const [sizeAadhar, setSizeAadhar] = useState(null);
  const [btnLoadingPan, setBtnLoadingPan] = useState(false);
  const [sizePan, setSizePan] = useState(null);
  const [sizeGst, setSizeGst] = useState(null);
  const [fileNameadhar, setFileNameadhar] = useState(null);
  const [fileNamePan, setFileNamePan] = useState(null);
  const [fileNameGst, setFileNameGst] = useState(null);
  const [uploadFileAadhar, setUploadFileAadhar] = useState("");
  const [uploadFilePan, setUploadFilePan] = useState("");
  const [uploadFileGst, setUploadFileGst] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const [addedCompanyId, setAddedCompanyId] = useState(null);
  const [pincodeList, setPincodeList] = useState([]);
  const [apiloading, setapiloading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [size, setSize] = useState(null);
  const [uploadFile, setUploadFile] = useState("");
  const [fileLink, setFileLink] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [companyDocumentId, setCompanyDocumentId] = useState(null);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { Option } = AutoComplete;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyDocumentList, setCompanyDocumentList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [sectorName, setSectorName] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [btnLoadingFile, setBtnLoadingFile] = useState(false);
  const [btnDisplay, setBtnDisplay] = useState("Add");
  const [apiloadingFile, setapiloadingFile] = useState(false);
  const [cityDropdownOptionsShipping, setCityShipping] = useState([]);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [OTP, setOTP] = useState(null);
  const [OTPPhone, setOTPPhone] = useState(null);

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);

  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);
  const [verifyAdhaar, setVerifyAdhaar] = useState(false);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [CId, setCId] = useState(null);

  useEffect(() => {
    console.log("statestate", state);
  }, [])

  

  //state initialisation
  const [stateDocumentTable, setStateDocumentTable] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const [errorMsg, setErrorMsg] = useState("");
  let filename = "";

  // fetch company onboarding details
  useEffect(() => {
    const getCompanyOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest("company/");
        console.log(apiResponse);
        if (apiResponse.data.success) {
          setState({
            ...apiResponse.data.data,
            name: apiResponse.data.data.name,
            pincode: apiResponse.data.data.pincode,
            // risk_and_compliance_title: apiResponse.data.data.risk_and_compliance_title,
            udhyam_aadharcard: apiResponse.data.data.udhyam_aadharcard,
            keypersons: apiResponse.data.data.keypersons.map((e) => ({
              person_name: e.person_name,
              email: e.email,
              designation: e.designation,
              department: e.department,
              contact_number: e.contact_number,
            })),
          });
          setFileLinkadhar(apiResponse.data?.data?.upload_aadharcard);
          setFileLinkPan(apiResponse.data?.data?.upload_pancard);
          setFileLinkGst(apiResponse.data?.data?.upload_gst);
          const url = apiResponse.data.data.company_logo;
          setIdentifyProfileUrl(apiResponse.data.data.company_logo);
          setCId(apiResponse.data.data.id);
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            pincode: apiResponse.data.data.pincode_number,
            phone: String(apiResponse.data.data.phone),
            city: apiResponse.data.data.city_name,
            trading_address_pincode:
              apiResponse.data.data.trading_address_pincode_number,
            udhyam_aadharcard: apiResponse.data.data.udhyam_aadharcard,
            registered_business_address_pincode:
              apiResponse.data.data.registered_business_address_pincode_number,
          });
          setWeightSizeFieldValue(apiResponse.data.data.keypersons);
          const response = apiResponse.data.data;
          if (
            response?.registered_business_address_state ===
              response?.trading_address_state &&
            response?.registered_business_address_city ===
              response?.trading_address_city &&
            response?.registered_business_address_building ===
              response?.trading_address_building &&
            response?.registered_business_address_area ===
              response?.trading_address_area &&
            response?.registered_business_address_landmark ===
              response?.trading_address_landmark &&
            response?.registered_business_address_pincode ===
              response?.trading_address_pincode
          ) {
            setSameAsCurrentAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("err_getCompanydetail"));
          sameAsCurrentAddress(false);
        }
        setFormSubmitted(true);

        if (apiResponse?.data?.data?.email_verified === true) {
          setVerificationResultEmail("success");
          setVerifyEmailButtonView(false);
        } else {
          setVerificationResultEmail(null);
          setVerifyEmailButtonView(true);
        }

        if (apiResponse?.data?.data?.phone_verified === true) {
          setVerificationResultContact("success");
          setVerifyPhoneButtonView(false);
        } else {
          setVerificationResultContact(null);
          setVerifyPhoneButtonView(true);
        }

        if (apiResponse?.data?.data?.company_pan_verified === true) {
          setVerificationResultPancard("success");
          setVerifyPancardButtonView(false);
        } else {
          setVerificationResultPancard(null);
          setVerifyPancardButtonView(true);
        }

        if (apiResponse?.data?.data?.udyam_aadhaar_no_verified === true) {
          setVerificationResultAadhaar("success");
          setVerifyAdhaarButtonView(false);
        } else {
          setVerificationResultAadhaar(null);
          setVerifyAdhaarButtonView(true);
        }

        if (apiResponse?.data?.data?.gst_no_verified === true) {
          setVerificationStatus("success");
          setVerifyGstButtonView(false);
        } else {
          setVerificationStatus(null);
          setVerifyGstButtonView(true);
        }

        setAddedCompanyId(CompanyId);
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    // if (CompanyId !== null) {
    //   getCompanyOnboarding();
    // }
  }, [CompanyId, t]);

  // Extract filename from URL if fileLinkPan exists
  const urlpan = state?.upload_pancard;
  let filenamepan = "";
  try {
    if (fileLinkPan) {
      filenamepan = urlpan.split("/").pop();
    }
  } catch (e) {
    filenamepan = "";
  }

  // Define GST pattern for validation
  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  // Handle changes in GST input field
  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);

    setState({ ...state, gst_no: value, gst_no_verified: false });
    // Debounce the API call to avoid immediate firing on each keystroke
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));
  };

  // Extract filename from URL if fileLinkGst exists
  const urlgst = state?.upload_gst;
  let filenamegst = "";
  try {
    if (fileLinkGst) {
      filenamegst = urlgst.split("/").pop();
    }
  } catch (e) {
    filenamegst = "";
  }

  // Extract filename from URL if fileLinkadhar exists
  const urladhaar = state?.upload_aadharcard;

  let filenameaadhar = "";
  try {
    if (fileLinkadhar) {
      filenameaadhar = urladhaar.split("/").pop();
    }
  } catch (e) {
    filenameaadhar = "";
  }

  // Handle changes in Pancard input field
  const handleInputPancardChange = (e) => {
    let { name, value } = e.target;
    console.log(e.target.value, e.target.name, "namesss");
    setVerificationResultPancard("");
    setVerifyPancard(true);
    setVerifyPancardButtonView(true);
    setState({
      ...state,
      [name]: value !== "" ? value : null,
      pan_verified: false,
    });
  };

  // fetch company document details
  useEffect(() => {
    const getCompanyDocument = async () => {
      setapiloadingFile(true);
      try {
        let filename1;
        const apiResponse = await getRequest(
          "company-attachment/" + companyDocumentId
        );

        if (apiResponse.data.success) {
          setDocumentState({
            ...apiResponse.data.data,
          });
          setapiloadingFile(false);
          try {
            filename1 = apiResponse.data.data.attachment_file.split("/").pop();
            setFileName(filename1);
          } catch (e) {
            filename1 = "";
            setFileName(null);
          }

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
          });
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
          setapiloadingFile(false);
        }
        setapiloadingFile(false);
      } catch (error) {
        setapiloadingFile(false);
      }
    };
    if (companyDocumentId !== null) {
      getCompanyDocument();
    }
  }, [companyDocumentId, t]);

  // fetch company document list
  useEffect(() => {
    const getCompanyDocumentList = async () => {
      setLoading(true);
      try {
        let apiResponse = await getRequest(
          `company-id-attachment/${addedCompanyId}/`,
          stateDocumentTable
        );

        if (apiResponse.data.success === true) {
          setCompanyDocumentList(apiResponse.data.data);

          settotalCount(apiResponse.data.count);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    if (addedCompanyId !== null) {
      getCompanyDocumentList();
    }
  }, [stateDocumentTable, reload, t, refreshGrid, addedCompanyId]);

  // fetch sector names on component mount
  useEffect(() => {
    getSectorName();
  }, []);

  // Functions to handle modal visibility and OTP rese
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the first modal

  const handleOk = () => {
    setIsModalOpen(false);
  };
  // Function to close the first modal and reset OTP and timer states
  const handleCancel = () => {
    setIsModalOpen(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoadingEmail(false);
    setState(initialState);
    formRef.current.resetFields(); 
  };

  // Function to open the phone modal
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };

  // Function to close the phone modal
  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };

  // Function to close the phone modal and reset OTP and timer statess
  // const handleCancelPhone = () => {
  //   setIsModalOpenPhone(false);
  //   setOTPPhone(null);
  //   setSecondsPhone(30);
  //   setMinutesPhone(1);
  //   setBtnLoadingPhone(false);
  //   setState(null);
  // };

  // Function to send OTP email and handle response
  // const handleSendOtpEmail = async () => {
  //   try {
  //     const payload = {
  //       email: state?.email ? state.email : "",
  //     };
  //     const response = await postRequest(`verified-otp/email-verify/`, payload);
  //     console.log(response, "responseddd");
  //     if (response.data.success) {
  //       const errorMessage = response?.data?.message || ""; // Adjust this line to get the message from your error response

  //       const emailVerificationRegex = /This [^ ]+ already Verify/; // Regex to match the email format in the message

  //       // Check if the error message matches the condition
  //       if (emailVerificationRegex.test(errorMessage)) {
  //         setVerifyEmailButtonView(false);

  //         setState((prevState) => ({
  //           ...prevState,
  //           email_verified: true,
  //         }));
  //         setVerificationResultEmail("success");
  //       } else {
  //         setState((prevState) => ({
  //           ...prevState,
  //           email_verified: false,
  //         }));
  //         showModal();
  //         setVerifyEmailButtonView(true);
  //       }
  //       SuccessNotificationMsg(response.data.message);
  //     } else {
  //       handleCancel();
  //       setVerificationResultEmail("");
  //     }
  //   } catch (error) {
  //     handleCancel();
  //     setVerifyEmailButtonView(true);
  //   }
  // };

  // Function to handle changes in Aadhaar input field
  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    setState({
      ...state,
      udhyam_aadharcard: value !== "" ? value : null,
      udyam_aadhaar_no_verified: false,
    });
  };

  // Function to handle email verification when the email is entered
  // const handleEmailVerify = async () => {
  //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex pattern
  //   const isEmailValid = emailPattern.test(state.email);
  //   if (isEmailValid) {
  //     await handleSendOtpEmail(); // Call handleSendOtpEmail if email is valid
  //   } else {
  //     setVerifyEmailButtonView(true);
  //     ErrorNotificationMsg("Enter valid email");
  //   }
  // };

  // Function to handle changes in email input field
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };

  // Function to fetch cities based on state for shipping information
  const getCityByStateForShipping = async (StateId) => {
    await getRequest(`city/${StateId}/`).then((response) => {
      setCityShipping(response.data.data);
    });
  };

  // Function to fetch sector names with no pagination
  const getSectorName = async (data) => {
    await getRequest("sectorname/?no_pagination=True", data).then(
      (response) => {
        setSectorName(response.data.data);
      }
    );
  };

  // Generic function to handle changes in form fields
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  // Function to handle changes when the "Same as current address" checkbox is toggled
  const handleSameAsCurrentAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);
    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_billing_address: true,
          trading_address_state: prevState.registered_business_address_state,
          trading_address_city: prevState.registered_business_address_city,
          trading_address_building:
            prevState.registered_business_address_building,
          trading_address_area: prevState.registered_business_address_area,
          trading_address_landmark:
            prevState.registered_business_address_landmark,
          trading_address_pincode:
            prevState.registered_business_address_pincode,
          trading_address_pincode_number:
            prevState.registered_business_address_pincode_number,
        };
      });
      formRef.current.setFieldsValue({
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });

      if (
        state?.registered_business_address_state !== null &&
        state?.registered_business_address_state !== undefined &&
        state?.registered_business_address_state !== ""
      ) {
        // console.log(state?.registered_business_address_state, "Inside");
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_billing_address: false,
        trading_address_state: "",
        trading_address_city: "",
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_pincode_number: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_state: "",
        trading_address_city: "",
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_pincode_number: "",
        trading_address_pincode: null,
      });
    }
  };

  // Function to handle search in shipping address field
  const onSearchShipping = async (value) => {
    setSearchValueShipping(value);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
  };

  // Function to handle changes in pincode for shipping address
  const handlePincodeShippingChange = async (trading_address_pincode) => {
    if (
      trading_address_pincode !== null &&
      trading_address_pincode !== undefined &&
      trading_address_pincode !== "" &&
      trading_address_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${trading_address_pincode}`
        );
        console.log(response, "responsed");
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            trading_address_state: state_name,
            trading_address_city: city_name,
            trading_address_pincode: id,
            trading_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            trading_address_state: state_name,
            trading_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: null,
        trading_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        trading_address_state: "",
        trading_address_city: "",
      });
    }
  };

  // Function to perform search operation based on pincode value
  const searchINShipping = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShipping(apiResponse.data.results.data);
    }
  };

  // Function to handle changes in pincode for billing address
  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode !== null &&
      registered_business_address_pincode !== undefined &&
      registered_business_address_pincode !== "" &&
      registered_business_address_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        console.log(response, "responsed");
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: null,
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };

  // Function to handle sector selection change
  const handleSectorSelectChange = async (value) => {
    setState({ ...state, sector: value });
  };

  // Function to verify GST number
  const handleGstNumberVerify = async () => {
    try {
      const gst = state?.gst_no;

      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gst || !gstRegex.test(gst)) {
        ErrorNotificationMsg(t("Invalid GST No."));
        setVerificationResultGST("error");
        return;
      }
      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);
      console.log(response, "responseddd");
      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully");
        setVerificationResultGST("success");
      } else {
        // Handle case when GST number is not valid
        ErrorNotificationMsg(t("Invalid GST No."));
        setVerificationResultGST("error");
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      setVerificationResultGST("error");
    }
  };

  // Function to handle changes in phone input field
  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact(""); // Reset verificationResultContact when phone number changes
  };

  // // Function to handle sending OTP for phone verification
  // const handleSendOtpPhone = async () => {
  //   try {
  //     // Prepare payload with phone number
  //     const payload = {
  //       phone_number: state?.phone || "",
  //     };

  //     // Send request to verify phone number
  //     const response = await postRequest(
  //       `verified-otp/phone-number-verify/`,
  //       payload
  //     );
  //     console.log(response, "responseddd Phone Number");

  //     if (response.data.success) {
  //       const errorMessage = response?.data?.message || "";
  //       const emailVerificationRegex = /This [^ ]+ already Verify/; // Regex to check if phone number is already verified

  //       if (emailVerificationRegex.test(errorMessage)) {
  //         // If phone number is already verified
  //         setVerifyPhoneButtonView(false);
  //         setState((prevState) => ({
  //           ...prevState,
  //           phone_verified: true,
  //         }));
  //         setVerificationResultContact("success");
  //       } else {
  //         // If phone number needs further verification
  //         setState((prevState) => ({
  //           ...prevState,
  //           phone_verified: false,
  //         }));
  //         showModalPhone(); // Show modal for additional verification
  //         setVerifyPhoneButtonView(true);
  //       }
  //       SuccessNotificationMsg(response.data.message);
  //     } else {
  //       // If verification fails
  //       setVerificationResultContact("");
  //       handleCancelPhone(); // Cancel verification process
  //       setVerifyPhoneButtonView(true);
  //     }
  //   } catch (error) {
  //     // Handle errors during verification
  //     setVerifyPhoneButtonView(true);
  //     handleCancelPhone();
  //     setVerificationResultContact("");
  //   }
  // };

  // Function to handle contact number verification
  // const handleContactNumberVerify = async () => {
  //   const contactNumber = state?.phone;
  //   const phoneNumberPattern = /^\d{12}$/; // Regex pattern for a 12-digit phone number

  //   // Validate contact number format
  //   if (contactNumber && phoneNumberPattern.test(contactNumber)) {
  //     await handleSendOtpPhone(); // Call handleSendOtpPhone if the number is valid
  //   } else {
  //     ErrorNotificationMsg("Enter valid mobile number");
  //   }
  // };

  // Function to verify Aadhaar number
  const handleAdhaarNumberVerify = async () => {
    try {
      const adhaarNumber = state?.udhyam_aadharcard;

      if (adhaarNumber) {
        setBtnLoadingAdhaar(true); // Set loading state
        // Send request to verify Aadhaar number
        const response = await getRequest(
          `/doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        console.log(response, "responseddd");

        if (response.data.results.data) {
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
        } else {
          // Handle invalid Aadhaar number
          ErrorNotificationMsg(t("Invalid number"));
          setVerificationResultAadhaar("error");
        }
        setBtnLoadingAdhaar(false); // Reset loading state
      }
    } catch (error) {
      // Handle errors during verification
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      setVerificationResultAadhaar("error");
    }
  };

  // Function to verify PAN card number
  const handlePancardNumberVerify = async () => {
    try {
      const pancard = state?.company_pan;
      const gstRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // Regex pattern for PAN card format

      if (!pancard || !gstRegex.test(pancard)) {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setVerificationResultPancard("error");
        return;
      }

      setBtnLoadingPan(true); // Set loading state
      // Send request to verify PAN card number
      const response = await getRequest(
        `doc-verification/pan/?pan_no=${pancard}`
      );
      console.log(response, "responseddd");

      if (response?.data?.data?.status === "id_found") {
        SuccessNotificationMsg("Pancard verified successfully");
        setVerificationResultPancard("success");
        setVerifyPancardButtonView(false);
        setState((prevState) => ({
          ...prevState,
          pan_verified: true,
        }));
      } else {
        ErrorNotificationMsg(t("Invalid pancard number"));
        setVerificationResultPancard("error");
      }
      setBtnLoadingPan(false);
    } catch (error) {
      ErrorNotificationMsg(t("Invalid Pan Number"));
      setVerificationResultPancard("error");
      setBtnLoadingPan(false);
    }
  };

  // Function to perform search operation for billing address pincode
  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };

  // Function to handle search input for billing address
  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    // Perform search if value length is greater than or equal to 4 characters
    value.length >= 4 ? searchINBilling(value) : setPincodeListBilling([]);
  };

  // Function to handle table changes (pagination, sorting, filtering)
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setStateDocumentTable({
      ...stateDocumentTable,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  // Function to get sorting enum value based on field and order
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "attachment_name" && sortOrder === "ascend") {
      sortingEnumKey = "attachment_name";
    }
    if (sortField === "attachment_name" && sortOrder === "descend") {
      sortingEnumKey = "-attachment_name";
    }
    if (sortField === "attachment_file" && sortOrder === "ascend") {
      sortingEnumKey = "attachment_file";
    }
    if (sortField === "attachment_file" && sortOrder === "descend") {
      sortingEnumKey = "-attachment_file";
    }
    return sortingEnumKey;
  };

  // Function to handle search input with debouncing
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearchTable);
  };

  // Function to update search state for document table
  const onSearchTable = (value) => {
    setStateDocumentTable({
      ...stateDocumentTable,
      search: value,
    });
  };
  // Configuration for row selection in a table
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys); // Update selected rows state
    },
  };

  // Debounced function for handling search input
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value); // Call the search function after delay
  }, 1000);

  // Function to handle archiving documents
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id); // Add the provided ID if no rows are selected
    }
    try {
      // Send request to archive documents
      let apiResponse = await postRequest("company-attachment-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("document_archive_successfully"));
        setReload(!reload); // Toggle reload state to refresh data
        setSelectedRow([]); // Clear selected rows
      } else {
        ErrorNotificationMsg(t("error_in_document_archive"));
      }
    } catch (error) {
      // Optionally handle or log errors
      // ErrorNotificationMsg(error);
    }
  };

  // Function to handle edit icon click
  const handleEditIconClick = (id) => {
    setCompanyDocumentId(id); // Set the document ID to be edited
    setBtnDisplay("Edit"); // Change button display to "Edit"
  };

  // Function to refresh the grid
  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid); // Toggle grid refresh state
  };

  // Function to set form field values based on data
  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["department" + objectKey] = objectValue.department;
      fieldObject["contact_number" + objectKey] = String(
        objectValue.contact_number
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject); // Set form values
  };

  // Validate phone number length
  const phoneValidLength = state.phone && state.phone;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }
    return Promise.resolve();
  };

  // Handle input field changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
    // Clear verification results based on field name
    if (name === "gst_no") {
      setVerificationResultGST("");
    }
    if (name === "company_pan") {
      setVerificationResultPancard("");
    }
    if (name === "company_udhyam_adhaar") {
      setVerificationResultAadhaar("");
    }
  };

  // Handle document input field changes
  const handleDocumentChange = (e) => {
    let { name, value } = e.target;
    setDocumentState({
      ...documentState,
      [name]: value !== "" ? value.toLowerCase() : null,
    });
  };

  // Handle pincode changes and update state
  const handlePincodeChange = (name, value) => {
    const selectedOption = pincodeList.find(
      (option) => option.pincode_number === value
    );
    const selectedId = selectedOption ? selectedOption.id : null;
    setState({ ...state, [name]: selectedId });
  };

  // Handle select input changes
  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  // Upload properties for PAN card
  const uploadPropsPan = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      setSizePan(file.size);
      if (file.size <= 2097152) {
        // Check if file size is within limit
        setSizePan(file.size);
        setUploadFilePan(file);
        setFileNamePan(file.name);
        setFileLinkPan(null);
        return true;
      } else {
        alert("File size exceeds 2MB.");
        return Promise.reject();
      }
    },
  };

  // Upload properties for Aadhaar card
  const uploadPropsAdhar = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      if (file.size <= 2097152) {
        // Check if file size is within limit
        setSizeAadhar(file.size);
        setUploadFileAadhar(file);
        setFileNameadhar(file.name);
        setFileLinkadhar(null);
        return true;
      } else {
        alert("File size exceeds 2MB.");
        return Promise.reject();
      }
    },
  };

  // Upload properties for GST document
  const uploadPropsGst = {
    accept: ".jpg, .png, .jpeg",
    showUploadList: false,
    beforeUpload: (file) => {
      setSizeGst(file.size);
      if (file.size <= 2097152) {
        // Check if file size is within limit
        setSizeGst(file.size);
        setUploadFileGst(file);
        setFileNameGst(file.name);
        setFileLinkGst(null);
        return true;
      } else {
        alert("File size exceeds 2MB.");
        return Promise.reject();
      }
    },
  };

  // Generic upload properties
  const uploadProps = {
    accept: ".jpg, .png",
    showUploadList: false,
    beforeUpload: (file, index) => {
      setSize(file.size);
      if (file.size <= 2097152) {
        // Check if file size is within limit
        setSize(file.size);
        setUploadFile(file);
        setFileName(file.name);
        setFileLink(null);
      } else {
        alert("File size exceeds 2MB.");
        return Promise.reject();
      }
    },
  };

  // Truncate file name for Aadhar card
  const truncateFileNameaadhar = (fileName, maxLength = 27) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extIndex = fileName.lastIndexOf(".");
    const extension = extIndex !== -1 ? fileName.slice(extIndex) : "";
    const truncated = fileName.slice(0, maxLength - extension.length);
    return `${truncated}...${extension}`; // Return truncated file name with extension
  };

  // Truncate file name for PAN card
  const truncateFileNameForPan = (fileName, maxLength = 27) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extIndex = fileName.lastIndexOf(".");
    const extension = extIndex !== -1 ? fileName.slice(extIndex) : "";
    const truncated = fileName.slice(0, maxLength - extension.length);
    return `${truncated}...${extension}`; // Return truncated file name with extension
  };

  // Truncate file name for GST file
  const truncateFileNameForgst = (fileName, maxLength = 27) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extIndex = fileName.lastIndexOf(".");
    const extension = extIndex !== -1 ? fileName.slice(extIndex) : "";
    const truncated = fileName.slice(0, maxLength - extension.length);
    return `${truncated}...${extension}`; // Return truncated file name with extension
  };

  // Truncate file name for any file
  const truncateFileName = (fileName, maxLength = 27) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const extIndex = fileName.lastIndexOf(".");
    const extension = extIndex !== -1 ? fileName.slice(extIndex) : "";
    const truncated = fileName.slice(0, maxLength - extension.length);
    return `${truncated}...${extension}`; // Return truncated file name with extension
  };

  // Handle file deletion for PAN card
  const handleDeletePan = () => {
    setState((prevState) => ({
      ...prevState,
      upload_pancard: null, // Clear the state for PAN card file
    }));
    setUploadFilePan("");
    setFileNamePan(null);
    setSizePan(null);
  };

  // Handle file deletion for GST file
  const handleDeleteGst = () => {
    setState((prevState) => ({
      ...prevState,
      upload_gst: null, // Clear the state for GST file
    }));
    setUploadFileGst("");
    setFileNameGst(null);
    setSizeGst(null);
  };

  // Handle file deletion for Aadhar card
  const handleDeleteAdhar = () => {
    setState((prevState) => ({
      ...prevState,
      upload_aadharcard: null, // Clear the state for Aadhar card file
    }));
    setUploadFileAadhar("");
    setFileNameadhar(null);
    setSizeAadhar(null);
  };

  // Delete PAN card file from server
  const handleFileDeletePan = async () => {
    const apiResponse = await patchRequest(
      `company/${CompanyId}/upload-pancard-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_pan_deleted_success"));
      setFileLinkPan(null);
      setFileNamePan(null);
      setSizePan(null);
    }
  };

  // Delete GST file from server
  const handleFileDeleteGst = async () => {
    const apiResponse = await patchRequest(
      `company/${CompanyId}/upload-gst-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_gst_deleted_success"));
      setFileLinkGst(null);
      setFileNameGst(null);
      setSizeGst(null);
    }
  };

  // Delete Aadhar card file from server
  const handleFileDeleteAdhar = async () => {
    const apiResponse = await patchRequest(
      `company/${CompanyId}/upload-aadharcard-delete/`
    );
    if (apiResponse.status) {
      SuccessNotificationMsg(t("image_aadhar_deleted_success"));

      setFileLinkadhar(null);

      setFileNameadhar(null);
      setSizeAadhar(null);
    }
  };
  // Function to handle the deletion of the uploaded file in the state
  const handleDelete = () => {
    // Update the state to remove the attachment file
    setState((prevState) => ({
      ...prevState,
      attachment_file: null,
    }));

    // Clear the file upload inputs
    setUploadFile("");
    setFileName(null);
    setSize(null);
  };

  // Function to delete the company image from the server
  const handleFileDelete = async () => {
    // Send a DELETE request to remove the company image based on the CompanyId
    const apiResponse = await deleteRequest(
      `company-image-delete/${CompanyId}/`
    );

    // If the deletion is successful, clear the file-related state values
    if (apiResponse.data.success) {
      setFileLink(null);
      setFileName(null);
      setSize(null);
    }
  };

  // Function to search for pincode information based on the input value
  const searchIN = async (value) => {
    // Send a GET request to search for pincode using the provided value
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );

    // If the search is successful, update the pincode list in the state
    if (apiResponse.data.results.success) {
      setPincodeList(apiResponse.data.results.data);
    }
  };

  // Function to handle selection of a pincode
  const onSelect = (data) => {
    // Update the search value state based on the selected data
    setSearchValue(!data ? "" : data);
  };

  // Function to handle the search input change for pincode
  const onSearch = async (value) => {
    // Update the search value state
    setSearchValue(value);

    // If the search input length is 4 or more, initiate the search
    value.length >= 4 ? searchIN(!value ? null : value) : setPincodeList([]);
  };

  // Function to update the risk and compliance title in the state
  // const updateRiskAndCompliance = (newValue) => {
  //   // Update the state with the new risk and compliance title
  //   setState((prevState) => ({
  //     ...prevState,
  //     risk_and_compliance_title: newValue,
  //   }));
  // };

  // Function to handle the change in shipping state selection
  const handleStateChangeShipping = (values) => {
    console.log(values, "Valuessss");

    // Update the state with the selected shipping state and reset the city
    setState({ ...state, state: values, city: null });

    // Clear the city shipping list
    setCityShipping([]);

    // If the state is selected, fetch the corresponding cities
    if (values !== null && values !== undefined) {
      getCityByStateForShipping(values); //1 0
    }
  };

  // Function to handle the change in city selection
  const handleCityChange = (values) => {
    // Update the state with the selected city
    setState({ ...state, city: values });
  };

  // Function to handle form submission for company details
  const handleSubmit = async () => {
    try {
      // Set the button loading state to true
      setBtnLoading(true);

      // Prepare the payload with the company details from the state
      const payload = {
        name: state.name,
        first_name: state.first_name,
        designation: state.designation,
        email: state.email,
        phone: state.phone,
        website: state.website,
        no_of_employees: state.no_of_employees,
        company_pan: state.company_pan,
        gst_no: state.gst_no,
        email_verified: state.email_verified,
        phone_verified: state.phone_verified,
        company_pan_verified: state.pan_verified,
        gst_no_verified: state.gst_no_verified,
        udyam_aadhaar_no_verified: state.udyam_aadhaar_no_verified,
        about_company: state.about_company,
        sector: state.sector,
        cin_no: state.cin_no,
        // risk_and_compliance_title: state.risk_and_compliance_title,
        udhyam_aadharcard: state.udhyam_aadharcard,
        registered_business_address_building:
          state.registered_business_address_building,
        registered_business_address_area:
          state.registered_business_address_area,
        registered_business_address_landmark:
          state.registered_business_address_landmark,
        registered_business_address_state:
          state.registered_business_address_state,
        registered_business_address_city:
          state.registered_business_address_city,
        registered_business_address_pincode:
          state.registered_business_address_pincode,
        trading_address_building: state.trading_address_building,
        trading_address_area: state.trading_address_area,
        trading_address_landmark: state.trading_address_landmark,
        trading_address_state: state.trading_address_state,
        trading_address_city: state.trading_address_city,
        trading_address_pincode: state.trading_address_pincode,
        keypersons:
          state.keypersons &&
          state.keypersons.every(
            (person) =>
              person.person_name === null &&
              person.email === null &&
              person.designation === null &&
              person.department === null &&
              person.contact_number === null
          )
            ? []
            : state.keypersons,
      };

      // Create FormData to handle file uploads along with the payload
      const formData = new FormData();
      formData.append("company_logo", uploadFileProfilePic);
      formData.append("upload_aadharcard", uploadFileAadhar);
      formData.append("upload_pancard", uploadFilePan);
      formData.append("upload_gst", uploadFileGst);
      formData.append("form_data", JSON.stringify(payload));

      let response;

      // Determine if it's a new company or an update, then send the appropriate request
      // if (CompanyId === null) {
        response = await postRequest("company/", formData);
      // } else {
      //   response = await patchRequest(`company/${CompanyId}/`, formData);
      // }

      // If the request is successful, handle the success scenario
      if (response.data.success) {
        setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg(
          CompanyId === null
            ? t("company_added_successfully")
            : t("company_updated_successfully")
        );
        setFormSubmitted(true);
        setBtnLoading(false);
        getCompanyOnboardingList();
        setIsModalOpen(false);
        handleCancel1();
        setReload((reload)=>!reload)
        
      }
    } catch (error) {
      // Handle any errors and stop the loading spinner
      setBtnLoading(false);
    }
  };

  // Function to handle form submission for company attachments
  const handleCompanySubmit = async () => {
    // Prepare the payload with the company ID and attachment name
    const payload = {
      company: addedCompanyId,
      attachment_name: documentState.attachment_name,
    };

    try {
      let apiResponse;

      // Set loading states for the file upload
      setBtnLoadingFile(true);
      setapiloadingFile(true);

      // Set custom headers for file upload
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // Create FormData to handle file upload along with the payload
      const formData = new FormData();
      formData.append("attachment_file", uploadFile);
      formData.append("form_data", JSON.stringify(payload));

      // Determine if it's a new attachment or an update, then send the appropriate request
      if (companyDocumentId === null) {
        apiResponse = await postRequest(
          "company-attachment/",
          formData,
          customerHeaders
        );
      } else {
        apiResponse = await patchRequest(
          `company-attachment/${companyDocumentId}/`,
          formData,
          customerHeaders
        );
      }

      // If the request is successful, handle the success scenario
      if (apiResponse.data.success === true) {
        handleRefreshGrid();
        SuccessNotificationMsg(
          companyDocumentId === null
            ? t("document_added_successfully")
            : t("document_updated_successfully")
        );
        setCompanyDocumentId(null);
        setDocumentState({ attachment_name: null });

        // Reset the form fields and state after successful submission
        formRef.current.setFieldsValue({
          attachment_name: "",
        });
        setDocumentState((prevState) => ({
          ...prevState,
          attachment_file: null,
        }));
        setBtnDisplay("Add");
        setUploadFile("");
        setFileName(null);
        setFileLink(null);
        setSize(null);
        setBtnLoadingFile(false);
        setapiloadingFile(false);
      }
    } catch (error) {
      // Handle any errors and stop the loading spinners
      setBtnLoadingFile(false);
      setapiloadingFile(false);
    }
  };

  // Function to handle the file validation before upload
  const beforeUpload = (file) => {
    // Check if the file type is JPG or PNG
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    // If the file is not JPG or PNG, show an error message and prevent upload
    if (!isJpgOrPng) {
      setErrorMsg("You can only upload JPG/PNG file!");
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }

    // Clear any error messages if the file type is correct
    setErrorMsg("");
    return false; // Prevent automatic upload, will handle manually
  };

  const handleDownloadPDF = (attachmentName, attachmentFileUrl) => {
    const doc = new jsPDF();

    // Add document title
    doc.text("Document Details", 20, 20);
    doc.text(`Attachment Name: ${attachmentName}`, 20, 30);

    // Try to load image from URL
    fetch(attachmentFileUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64data = reader.result;

          try {
            // Add image to PDF (jpeg/png automatically detected)
            doc.addImage(base64data, "JPEG", 20, 40, 100, 100);
          } catch (e) {
            console.error("Image error:", e);
            doc.text("Image could not be loaded", 20, 50);
          }

          // Save PDF
          doc.save(`${attachmentName}.pdf`);
        };

        reader.readAsDataURL(blob);
      })
      .catch((err) => {
        console.error("Failed to load image:", err);
        doc.text("Failed to load image", 20, 50);
        doc.save(`${attachmentName}.pdf`);
      });
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "attachment_name",
      key: "attachment_name",
      sorter: true,
    },
    {
      title: "Document",
      dataIndex: "attachment_file",
      key: "attachment_file",
      sorter: true,
      render: (attachment_file) =>
        attachment_file && (
          <>
            <a
              style={{ textDecoration: "none", color: "black" }}
              href={`${attachment_file}`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={attachment_file}
                style={{ width: "50px", height: "50px" }}
                alt=""
              />
            </a>
          </>
        ),
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space>
          <Editicon onClick={() => handleEditIconClick(record.id)} />

          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>

          <Tooltip title="Download">
            <DownloadOutlined
              style={{ cursor: "pointer", color: "#1890ff" }}
              onClick={() =>
                handleDownloadPDF(
                  record.attachment_name,
                  record.attachment_file
                )
              }
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      {/* <div className="ListingTopBar">
        <div className="pagenamewrap">
          {!apiloading ? (
            <div className="pagename">
              <h3>
                {CId ? `Edit Company Onboarding` : t("addCompanyOnboarding")}
              </h3>
              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to="/company-onboarding">
                    {" "}
                    {t("companyOnboarding")}
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  {CId ? `Edit Company Onboarding` : t("addCompanyOnboarding")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          ) : (
            ""
          )}
        </div>
      </div> */}

      <section className="grid-sec FormSection Container">
        <div className="FormBody newcompany">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent">
              <div className="formwrapper">
                <Spin spinning={apiloading}>
                  <Form
                    onFinish={handleSubmit}
                    autoComplete="off"
                    ref={formRef}
                  >
                    <Row gutter={[15]}>
                      <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                        <CompanyOnboardingLogo
                          setUploadFileProfilePic={setUploadFileProfilePic}
                          fileList={fileList}
                          setFileList={setFileList}
                          identifyProfileUrl={identifyProfileUrl}
                          setIdentifyProfileUrl={setIdentifyProfileUrl}
                          beforeUpload={beforeUpload}
                        />
                      </Col>
                    </Row>

                    <h3
                      style={{
                        backgroundColor: "#F8F8F8",
                        padding: "10px 20px",
                        borderRadius: "10px",
                        margin: "10px 0",
                      }}
                    >
                      {t("Business Information")}
                    </h3>
                    <Row gutter={[10]}>
                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            name="gst_no"
                            label={t("place_gst_no5")}
                            placeholder={t("place_gst_no")}
                            rules={t("val_gst_no")}
                            pattern={
                              "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                              "[A-Z]{1}[1-9A-Z]{1}" +
                              "Z[0-9A-Z]{1}$"
                            }
                            prefix={<IdcardOutlined />}
                            //  disabled={CompanyId !== null}
                            handleInputChange={handleGstInputChange}
                          />
                          {/* {verifyGstButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  label={t("Verify")}
                                  className="SaveGradiantBtn verify"
                                  loading={btnLoadingVerifyGst}
                                  onClick={handleGstNumberVerify}
                                  disabled={
                                    state?.gst_no ? verifyGstDisable : false
                                  }
                                />
                              ) : (
                                ""
                              )} */}

                          {verificationStatus === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            name="udhyam_aadharcard"
                            label={t("Udyam Number")}
                            placeholder={t("Enter Udyam Number")}
                            // rules={t("Please enter valid udyam Number")}
                            prefix={<IdcardOutlined />}
                            handleInputChange={handleInputAdhaarChange}
                          />
                          {/* {verifyAdhaarButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleAdhaarNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingAdhaar}
                                />
                              ) : (
                                ""
                              )} */}

                          {verificationResultAdhaar === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="verifywrap">
                          <InputField
                            name="company_pan"
                            label={t("label_client_pan")}
                            placeholder={t("pl_client_pan")}
                            pattern={"^[A-Z]{5}[0-9]{4}[A-Z]{1}$"}
                            nonRequiredRules={t("val_company_pan")}
                            prefix={<IdcardOutlined />}
                            handleInputChange={handleInputPancardChange}
                          />
                          {/* {verifyPancardButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handlePancardNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingPan}
                                />
                              ) : (
                                ""
                              )} */}
                          {verificationResultPancard === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <InputField
                          name="name"
                          label={t("label_company_name")}
                          placeholder={t("pl_company_name")}
                          rules={t("val_company_name")}
                          prefix={<Vector />}
                          // pattern={"^[a-zA-Z ]+$"}
                          handleInputChange={handleInputChange}
                          max={20}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={6}
                        xl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="no_of_employees"
                          label={t("label_no_of_employee")}
                          prefix={<User />}
                          rules={[
                            {
                              required: false,
                              message: <Trans>{t("val_no_of_employee")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            showArrow
                            allowClear
                            showSearch
                            placeholder={t("pl_no_of_employee")}
                            optionFilterProp="children"
                            onChange={(value) =>
                              handleSelectChange("no_of_employees", value)
                            }
                          >
                            <Select.Option value="1-10 employees">
                              1-10 employees
                            </Select.Option>
                            <Select.Option value="11-50 employees">
                              11-50 employees
                            </Select.Option>
                            <Select.Option value="51-200 employees">
                              51-200 employees
                            </Select.Option>
                            <Select.Option value="201-500 employees">
                              201-500 employees
                            </Select.Option>
                            <Select.Option value="501-1000 employees">
                              501-1000 employees
                            </Select.Option>
                            <Select.Option value="1001-5000 employees">
                              1001-5000 employees
                            </Select.Option>
                            <Select.Option value="5001-10000 employees">
                              5001-10000 employees
                            </Select.Option>
                            <Select.Option value="10000 + employees">
                              10000+ employees
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={6}
                        xl={6}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="cin_no"
                          label={t("label_cin_number")}
                          placeholder={t("pl_cin_number")}
                          handleInputChange={handleInputChange}
                          rules={t("val_cin_number")}
                          pattern={"^(?! +$)[a-zA-Z0-9_ ]+$"}
                          max={21}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        xl={8}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name="sector"
                          label=" Sector Name"
                          prefix={<User />}
                        >
                          <Select
                            showArrow
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder="Enter sector name"
                            onChange={(value) =>
                              handleSectorSelectChange(value)
                            }
                          >
                            {sectorName.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.sector_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={6}
                        xl={6}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="website"
                          label={t("pl_website")}
                          placeholder={t("place_website")}
                          pattern={
                            // "^((https?|ftp|smtp)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$"
                            "^((https?|ftp|smtp)://)?(www\\.)?[a-z0-9]+(-[a-z0-9]+)*\\.(com|org|net|co|in|co\\.in|[a-z]{2,})$"
                          }
                          nonRequiredRules={t("val_website")}
                          prefix={<Website />}
                          handleInputChange={handleInputChange}
                        />
                      </Col>

                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={6}
                        xl={6}
                        className="TextFeild gutter-row"
                      >
                        <TextAreaField
                          name="about_company"
                          label={t("pl_about_company")}
                          placeholder={t("place_about_company")}
                          nonRequiredRules={t("val_about_company")}
                          prefix={<About />}
                          handleInputChange={handleInputChange}
                        />
                      </Col>

                      {/* <Col
                            xs={24}
                            sm={24}
                            md={12}
                            lg={6}
                            xl={6}
                            className="TextFeild gutter-row"
                          >
                            <Form.Item
                              className="radioitem"
                              name="risk_and_compliance_title"
                              label="Risk And Compliance"
                              initialValue={false}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                            >

                              <RiskAndCompliance
                                value={state.risk_and_compliance_title}
                                onChange={updateRiskAndCompliance}
                              />
                            </Form.Item>

                          </Col> */}
                    </Row>
                    <h3
                      style={{
                        backgroundColor: "#F8F8F8",
                        padding: "10px 20px",
                        borderRadius: "10px",
                        margin: "10px 0",
                      }}
                    >
                      {t("Contact Information")}
                    </h3>
                    <Row gutter={5}>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={6}
                        xl={6}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="first_name"
                          label={t("label_person_name")}
                          placeholder={t("pl_person_name")}
                          pattern={"^[a-zA-Z ]+$"}
                          rules={t("val_person_name")}
                          prefix={<Name />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={6}
                        lg={4}
                        xl={4}
                        className="TextFeild gutter-row"
                      >
                        <InputField
                          name="designation"
                          label={t("label_designation")}
                          pattern={"^[a-zA-Z ]+$"}
                          placeholder={t("place_designation")}
                          rules={t("val_designation")}
                          prefix={<AddressLine />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={7} xl={7}>
                        <div className="verifywrap">
                          <EmailField
                            name="email"
                            label={t("label_email")}
                            placeholder={t("pl_email_3")}
                            rules={t("val_email")}
                            prefix={<Email />}
                            handleInputChange={handleInputChangeEmail}
                          />
                          {/* {verifyEmailButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleEmailVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingEmail}
                                />
                              ) : (
                                ""
                              )} */}

                          {verificationResultEmail === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                          )}
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={7} xl={7}>
                        <div className="verifywrap">
                          <Form.Item
                            name="phone"
                            label={t("label_mobileNumber")}
                            placeholder={t("pl_mobileNumber")}
                            rules={[
                              {
                                required: true,
                                validator: validatePhoneNumber,
                                message: (
                                  <Trans> {t("val_mobileNumber")}</Trans>
                                ),
                              },
                            ]}
                          >
                            <PhoneInput
                              className="PhoneSection"
                              country={"in"}
                              value={state?.phone}
                              onChange={handlePhoneInputChange}
                            />
                          </Form.Item>
                          {/* {verifyPhoneButtonView === true ? (
                                <ButtonField
                                  type="primary"
                                  className="SaveGradiantBtn verify"
                                  onClick={handleContactNumberVerify}
                                  label={t("Verify")}
                                  loading={btnLoadingPhone}
                                />
                              ) : (
                                ""
                              )} */}

                          {verificationResultContact === "success" && (
                            <img
                              src={verifybtn}
                              style={{ height: "36px", marginTop: "29px" }}
                            ></img>
                          )}
                        </div>
                      </Col>
                      <Row
                        gutter={32}
                        style={{
                          borderTop: "2px solid #d9d9d9",
                          padding: "24px",
                          backgroundColor: "#fafafa",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                        }}
                      >
                        <Col xs={24} xl={12} className="bdr">
                          <div className="colwrap">
                            <div
                              className="colsubtitle"
                            >
                              Registered Business Address
                            </div>
                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_building"
                                  label={t("Shop No., Building, Apartment")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_address")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("pl_street_address")}
                                    value={
                                      state.registered_business_address_building
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_area"
                                  label={t("Area, Street, Sector, Village")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_address")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("pl_street_address")}
                                    value={
                                      state.registered_business_address_area
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_landmark"
                                  label={t("pl_landmark")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_land_mark")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_land_mark")}
                                    value={
                                      state.registered_business_address_landmark
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "registered_business_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_pincode"
                                  label={t("pl_pincode")}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <AutoComplete
                                    className="autoComplete"
                                    onSearch={onSearchBilling}
                                    value={
                                      state.registered_business_address_pincode
                                    }
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={handlePincodeBillingChange}
                                  >
                                    {pincodeListBilling.map((option) => (
                                      <Option
                                        key={option.id}
                                        value={option.pincode_number}
                                      >
                                        {option.pincode_number}
                                      </Option>
                                    ))}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_city"
                                  label={t("pl_city")}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_city")}
                                    value={
                                      state.registered_business_address_city
                                    }
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="registered_business_address_state"
                                  label={t("pl_state_province")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    value={
                                      state.registered_business_address_state
                                    }
                                    placeholder={t("place_state")}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col xs={24} xl={12}>
                          <div className="colwrap">
                            <div className="colsubtitle">
                              Current Business Address
                              <Tooltip
                                title="Same as Billing Address"
                                name="same_as_billing_address"
                              >
                                <Checkbox
                                  style={{ marginLeft: "10px" }}
                                  checked={sameAsCurrentAddress}
                                  onChange={(e) =>
                                    handleSameAsCurrentAddressChange(e)
                                  }
                                >
                                  Same as my business address
                                </Checkbox>
                              </Tooltip>
                            </div>
                            <Row gutter={16}>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_building"
                                  label={t("Shop No., Building, Apartment")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_address")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("pl_street_address")}
                                    value={state.trading_address_building}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_building",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_area"
                                  label={t("Area, Street, Sector, Village")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_address")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("pl_street_address")}
                                    value={state.trading_address_area}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_area",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_landmark"
                                  label={t("pl_landmark")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_please_enter_land_mark")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_land_mark")}
                                    value={state.trading_address_landmark}
                                    onChange={(e) =>
                                      handleChange(
                                        "trading_address_landmark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_pincode"
                                  label={t("pl_pincode")}
                                  prefix={<ZipCode />}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>
                                          {t("val_postal_zip_code")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <AutoComplete
                                    className="autoComplete"
                                    onSearch={onSearchShipping}
                                    value={state.trading_address_pincode}
                                    optionFilterProp="children"
                                    allowClear
                                    placeholder={t("pl_pincodeselect")}
                                    onChange={handlePincodeShippingChange}
                                  >
                                    {pincodeListShipping.map((option) => (
                                      <Option
                                        key={option.id}
                                        value={option.pincode_number}
                                      >
                                        {option.pincode_number}
                                      </Option>
                                    ))}
                                  </AutoComplete>
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_city"
                                  label={t("pl_city")}
                                  rules={[
                                    {
                                      required: true,
                                      message: <Trans>{t("val_city")}</Trans>,
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_city")}
                                    value={state.trading_address_city}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} md={12}>
                                <Form.Item
                                  name="trading_address_state"
                                  label={t("pl_state_province")}
                                  rules={[
                                    {
                                      required: true,
                                      message: (
                                        <Trans>{t("val_state_province")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("place_state")}
                                    value={state.trading_address_state}
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </Row>

                    <div className="FormFooter">
                      <ButtonField
                        type="primary"
                        className="CancelGradiantBtn"
                        htmlType="button"
                        label={t("cancel")}
                        onClick={handleCancel}
                      />
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn"
                        htmlType="Submit"
                        label={t("save")}
                        loading={btnLoading}
                      />
                    </div>
                  </Form>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Modal
        className="ModelPopupSec"
        title={"Verify Email"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        <VerifyOtpModal
          handleCancel={handleCancel}
          setVerifyEmailButtonView={setVerifyEmailButtonView}
          OTP={OTP}
          setOTP={setOTP}
          state={state}
          setState={setState}
          setMinutes={setMinutes}
          setSeconds={setSeconds}
          seconds={seconds}
          minutes={minutes}
          handleSendOtpEmail={handleSendOtpEmail}
          setVerificationResultEmail={setVerificationResultEmail}
        />
      </Modal>
      <Modal
        className="ModelPopupSec"
        title={"Verify Mobile"}
        open={isModalOpenPhone}
        onOk={handleOkPhone}
        onCancel={handleCancelPhone}
        closable={handleCancelPhone}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        <PhoneOtpVerify
          handleCancelPhone={handleCancelPhone}
          setVerifyPhoneButtonView={setVerifyPhoneButtonView}
          OTP={OTPPhone}
          setOTP={setOTPPhone}
          state={state}
          setState={setState}
          setMinutes={setMinutesPhone}
          setSeconds={setSecondsPhone}
          seconds={secondsPhone}
          minutes={minutesPhone}
          handleSendOtpPhone={handleSendOtpPhone}
          setVerificationResultContact={setVerificationResultContact}
        />
      </Modal> */}
    </>
  );
};

AddNewClient.propTypes = {
  handleCancel1: PropTypes.func.isRequired,
  setIsModalOpen: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.func.isRequired,
  getCompanyOnboardingList: PropTypes.func.isRequired,
  setReload:PropTypes.bool.isRequired,
  reload:PropTypes.bool.isRequired,
};

export default AddNewClient;
